<template>
    <v-dialog
    v-model="localDialog"
    width="35%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
    >
        <v-card>
            <v-card-title class="text-h6">
                <span>{{ isEntryMode ? "Add Asset Document" : "Update Asset Document" }}</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
                <v-form @submit.prevent="submit" ref="assetDocumentsSetup">
                    <v-row>
                        <v-col cols="12" class="pb-0">
                            <v-label class="text-subtitle-1 font-weight-bold mb-1"
                            >Title</v-label>

                            <v-text-field
                            density="compact" 
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="title.value.value"
                            :error-messages="title.errorMessage.value"
                            class="visually-hidden-label"
                            clearable
                            >
                                <template #label>
                                    Title <span class="text-red-accent-4">*</span>
                                </template>
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" class="py-0">
                            <v-label class="text-subtitle-1 font-weight-bold mb-0">
                                File
                            </v-label>
                            <v-file-upload
                            class="h-25 visually-hidden-label"
                            title="Drop Component file here"
                            prepend-icon=""
                            prepend-inner-icon="mdi-paperclip"
                            variant="outlined"
                            density="compact"
                            show-size
                            bg-color="grey-lighten-5"
                            v-model="file.value.value"
                            :error-messages="file.errorMessage.value"
                            accept="*"
                            clearable
                            />
                        </v-col>
                    </v-row>

                    <v-row class="justify-end mt-0 mb-2 mx-2">
                        <v-checkbox
                            label="Active"
                            v-model="status.value.value"
                            :error-messages="status.errorMessage.value"
                            density="compact"
                            variant="outlined"
                            hide-details
                            single-line
                            color="primary"
                            true-value="1"
                            false-value="0"
                        ></v-checkbox>
                    </v-row>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-layout class="justify-end">
                            <v-btn
                                class="bg-red"
                                variant="flat"
                                type="reset"
                                @click="closeDialog"
                                >Close</v-btn
                            >
                            <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                                {{ isEntryMode ? "Save" : "Update" }}
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import { fileServerUrl } from "@/store/api";
import { getCurrentInstance } from "vue";

const DEFAULT_IMAGE = '/src/assets/no_preview.jpeg';

export default {
    title: "AssetDocumentsSetup",
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: () => ({
                id: null,
                asset_register_id: null,
                title: "",
                status: "1",
            }),
        },
    },
    data() {
        return {
            mainId :null,
            localDialog: this.dialog,

            selectedImage: null,
            errorMessages: "",
            preview: "/src/assets/no_preview.jpeg",
            isEntryMode: true,
        };
    },
    watch: {
        dialog(val) {
            this.localDialog = val;
        },
        localDialog(val) {
            this.$emit("update:dialog", val);
        },
        data: {
            handler(newData) {
                console.log("opened modal",newData);
                this.isEntryMode = !newData.id;
                this.resetForm({ errors: {}, touched: {} });
                this.asset_document_id.setValue(newData.id || "", false);
                this.asset_register_id.setValue(newData.asset_register_id || null, false);
                this.title.setValue(newData.title || "", false);
                this.status.setValue(String(newData.status), false);
            },
        },
    },
    created() {
        // if(this.$store.getters.getBrandList.length === 0) {
            this.brandLoading = true,
            this.$store.dispatch("getBrandList").then((response) => {
                this.brandLoading = false;
            })
        // }
        // if(this.$store.getters.getAssetStatusTypesList.length === 0) {
            this.assetStatusLoading = true,
            this.$store.dispatch("getAssetStatusTypesList").then((response) => {
                this.assetStatusLoading = false;
            })
        // }
    },
    computed: {
        getBrandList() {
            const brands = this.$store.getters.getBrandList;
            return brands;
        },
        getAssetStatusTypesList() {
            const statusTypes = this.$store.getters.getAssetStatusTypesList;
            return statusTypes;
        }
    },
    methods: {
        updateDialog(val) {
            this.$emit("update:dialog", val);
        },
        closeDialog() {
            this.$emit("update:dialog", false);
        },
    },
    setup(props, { emit }) {
        const { proxy } = getCurrentInstance();
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                title: yup.string().trim().required("Title is required").max(255, "Title cannot exceed 255 characters").label("Title"),
                file: yup.mixed().nullable("File is required").label("File"),
            }),
        });

        const asset_document_id = useField("asset_document_id");
        const title = useField("title");
        const asset_register_id =useField("asset_register_id");
        const status = useField("status");
        const file = useField("file");
        const errorMessages = ref("");
        const loading = ref("");
        const selectedImage  = ref(null);
        const preview = ref(DEFAULT_IMAGE);
        const store = useStore();
        
        const submit = handleSubmit((values) => {   
            const asset_id = proxy.mainId;
            values.asset_register_id = asset_id;

            if(!values.file || values.file === undefined || values.file === "") {
                if(proxy.isEntryMode) {
                    toast.error("File is required");
                    return;
                }
            }
            
            const formData = new FormData();
            Object.keys(values).forEach((key) => {
                formData.append(key, values[key] || "");
            });

            if (proxy.selectedImage) {
                formData.append("image", proxy.selectedImage);
            }

            store
                .dispatch("saveUpdateAssetDocument", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    resetForm();
                    emit("update:dialog", false);
                    toast.success(response.data.message);
                    proxy.selectedImage = null;
                    store.dispatch("getAssetDocumentsList", { asset_register_id: asset_id });
                })
                .catch((error) => {
                    toast.error(error?.response?.data?.message || "Something went wrong");
                });
        });

        return {
            submit,
            title,
            asset_document_id,
            asset_register_id,
            status,
            file,
            errorMessages,
            selectedImage,
            preview,
            resetForm,
            loading,
        };
    },
    mounted() {
        const id = this.$route.params.id;
        this.mainId = id;
    },
};
</script>
